<header class="mat-elevation-z3">
    <mat-toolbar class="p-0">
        <nav class="navbar-header main-view w-100">
            <div class="header-right-32 d-flex justify-content-center mt-1 p-0">
                <div  class="cursor mr-2"><img class="hartman-img" alt="App Logo" (click)="redirectDashboard()" src="assets/img/logo-hartmann.svg"></div>
                    <div><img alt="Health Logo" class="health-logo" src="assets/img/svg/health-plus.svg"></div>
            </div>
            <div class="flex-spacer"></div>
        </nav>
    </mat-toolbar>
</header>